<div class="feature-lock" [class.feature-lock--locked]="locked">
  <ng-content></ng-content>
  @if (locked && !hideBadge) {
    <span class="feature-lock__badge" aria-hidden="true">
      <bv-icon class="feature-lock__icon" name="lock"></bv-icon>
    </span>
  }
  <!-- Shield: when locked, fully covers the projected control to swallow
  its click and route through onLockedClick. CSS pointer-events alone
  doesn't reach projected content reliably across view encapsulation. -->
  @if (locked) {
    <div
      class="feature-lock__shield"
      (click)="onLockedClick($event)"
    ></div>
  }
</div>

<app-locked-feature-dialog
  [feature]="feature"
  [tier]="tier"
  [open]="lockedDialogOpen"
  (closed)="lockedDialogOpen = false"
></app-locked-feature-dialog>
